import type { ResponseItem } from '@/types/content';
import { getPerson, stanceClass } from '@/utils/content';

interface ResponseCardProps {
  item: ResponseItem;
  caseTitle?: string;
}

export default function ResponseCard({ item, caseTitle }: ResponseCardProps) {
  const person = getPerson(item.personId);
  if (!person) return null;

  return (
    <article className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 flex flex-col h-full">
      <div className="flex items-start gap-3">
        <img
          src={person.avatar}
          alt={`${person.name} 头像`}
          title={`${person.name} 的回应 - 911吃瓜`}
          className="w-11 h-11 rounded-full object-cover object-top shrink-0"
        />
        <div className="min-w-0 flex-1">
          <div className="flex items-center flex-wrap gap-2">
            <span className="font-heading font-bold text-foreground-950">{person.name}</span>
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${stanceClass[item.stance] ?? stanceClass['未回应']}`}>
              {item.stance}
            </span>
          </div>
          <p className="text-xs text-foreground-500 mt-0.5">{person.role}</p>
        </div>
        <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
          <i className="ri-chat-quote-line" />
        </span>
      </div>

      <p className="mt-3 text-sm leading-7 text-foreground-700 flex-1">“{item.content}”</p>

      <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between flex-wrap gap-2 text-xs text-foreground-500">
        <span className="flex items-center gap-1 whitespace-nowrap">
          <i className="ri-price-tag-3-line" />
          来源：{item.source}
        </span>
        <span className="whitespace-nowrap">{item.date}</span>
      </div>
      {caseTitle && (
        <p className="mt-2 text-xs text-foreground-400 truncate">关联事件：{caseTitle}</p>
      )}
    </article>
  );
}